import HttpService from './http.service';

class RegionsService {
  getRegions() {
    return HttpService.get('regions')
      .then((res) => res.data);
  }

  suggestRegions(params) {
    return HttpService.get('regions/suggestions', { params })
      .then((res) => res.data);
  }

  getRegion(id) {
    return HttpService.get(`regions/${id}`)
      .then((res) => res.data);
  }

  createRegion(region) {
    return HttpService.post('regions', region)
      .then((res) => res.data);
  }

  updateRegion(region) {
    return HttpService.patch(`regions/${region.id}`, region)
      .then((res) => res.data);
  }

  deleteRegion(region) {
    return HttpService.delete(`regions/${region.id}`)
      .then((res) => res.data);
  }
}

export default new RegionsService();
